import {Category} from "./category";

export class RaceSettings {
  raceId?: number;
  applicationProcedure?: number;
  typeOfApplication?: number;
  teamType?: number;
  selectionOfTeamMembersType?: number;
  teamNameRequired?: boolean;
  genderRequired?: boolean;
  measurementType?: number;
  measurementPrecisionType?: number;
  startByType?: number;
  resultsPerPage?: number;
  topRanked?: number;
  teamParticipantsForRanking?: number;
  teamRankingGenderSeparation?: number;
  rankingGroups?: string;
  participantsFromRankingGroup?: number;
  groupRankingSeparation?: number;
  teamRankingTeamSeparation?: number;
  penaltyMinutes?: number;
  controlPoints?: number;
  minimumLapDuration?: string;
  jaguarNumberShift?: number;
  rotatingOrder?: number;
  rotatingResultsDisplay?: number;
  rotatingResultsSeconds?: number;
  pic2GoEventId?: string;
  pic2GoEventUniqueCode?: string;
  registrationExternalUrl?: string;
  category?: Category;

  blockStart?: boolean;
  maxParticipantsInStartBlock?: number;

  enableGroupRegistrationPayment?: boolean;
  maxGroupRegisteredParticipants?: number;
  useGroupRanking?: boolean;
  timingSystem?: number;
  timingEquipment?: number;

  usingUploadRoute?: boolean;
  displayControlPoints?: boolean;
  showRouteProfile?: boolean;
  enableGPXDownload?: boolean;
  usingDistanceMarkersOnRoute?: boolean;
  distanceMarkersOnRoute?: number[];

  constructor() {
    this.applicationProcedure = undefined;
    this.typeOfApplication = undefined;
    this.teamType = undefined;
    this.selectionOfTeamMembersType = undefined;
    this.teamNameRequired = undefined;
    this.genderRequired = undefined;
    this.measurementType = undefined;
    this.measurementPrecisionType = undefined;
    this.startByType = undefined;
    this.resultsPerPage = undefined;
    this.topRanked = undefined;
    this.teamParticipantsForRanking = undefined;
    this.teamRankingGenderSeparation = undefined;
    this.rankingGroups = undefined;
    this.participantsFromRankingGroup = undefined;
    this.groupRankingSeparation = undefined;
    this.teamRankingTeamSeparation = undefined;
    this.penaltyMinutes = undefined;
    this.controlPoints = undefined;
    this.minimumLapDuration = undefined;
    this.jaguarNumberShift = undefined;
    this.rotatingOrder = undefined;
    this.rotatingResultsDisplay = undefined;
    this.rotatingResultsSeconds = undefined;
    this.pic2GoEventId = undefined;
    this.pic2GoEventUniqueCode = undefined;
    this.registrationExternalUrl = undefined;
    this.category = undefined;
    this.enableGroupRegistrationPayment = undefined;
    this.maxGroupRegisteredParticipants = undefined;
    this.useGroupRanking = undefined;
    this.timingSystem = undefined;
    this.timingEquipment = undefined;
    this.usingUploadRoute = undefined;
    this.displayControlPoints = undefined;
    this.showRouteProfile = undefined;
    this.enableGPXDownload = undefined;
    this.usingDistanceMarkersOnRoute = undefined;
    this.distanceMarkersOnRoute = undefined;
  }
}

export enum TimingSystem {
  ELECTRONIC = 1,
  PLATFORM = 2,
  EXTERNAL = 3
}

export enum ApplicationProcedureTypes {
  STANDARD = 1,
  CYCLING = 2,
  TRIATHLON = 3,
  STAGE_RACE = 4
}

export enum GenderSeparationTypes {
  NOT_USED = 1,
  TOGETHER_NO_GENDER_DIFFERENCE = 2,
  SEPARATE_BY_GENDER = 3
}

export enum MeasurementTypes {
  GUN_TIME_ONLY = 1,
  CHIP_TIME_ONLY = 2,
  GUN_TIME_PRIMARY = 3,
  CHIP_TIME_PRIMARY = 4,
  EXTERNAL_IMPORT = 5,
}

export enum MeasurementPrecisionTypes {
  SECONDS = 1,
  TENTHS = 2,
  HUNDREDTHS = 3,
  THOUSANDTHS = 4,
}

export enum StartByTypeTypes {
  ALL = 1,
  SEPARATE_BY_GENDER = 2,
}

export enum DistanceMarkers {
  ZeroOneKm = 1,
  ZeroFiveKm = 2,
  OneKm = 3,
  TwoKm = 4,
  FiveKm = 5,
  TenKm = 6,
  TwentyKm = 7,
  TwentyFiveKm = 8
}

export enum TeamRankingTeamSeparationTypes {
  NOT_USED = 1,
  GROUP_ONLY = 2,
  TEAM_AND_GROUP = 3
}


export enum PenaltyMinutesTypes {
  NOT_VISIBLE = 1,
  VISIBLE_TO_PUBLIC = 2,
  VISIBLE_TO_ADMINISTRATION = 3,
  ALWAYS_VISIBLE = 4
}

export enum TimingEquipments {
  MACSHA = 1,
  JAGUAR = 2,
  MY_LAPS = 3,
  RACE_RESULTS = 4,
  OTHER = 5
}

export enum RotatingOrderTypes {
  ABSOLUTE_ORDER = 1,
  MEN_FIRST_WOMEN_SECOND = 2,
  WOMEN_FIRST_MEN_SECOND = 3,
}

